import { forwardRef, useId } from 'react'
import type { TextareaHTMLAttributes, ReactNode } from 'react'
import { fieldControl } from './formClasses'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: ReactNode
  hint?: ReactNode
  error?: ReactNode
  className?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, error, className = '', ...props },
  ref
) {
  const id = useId()
  const hintId = hint ? `${id}-hint` : undefined
  const errorId = error ? `${id}-error` : undefined
  const describedBy = [errorId, hintId].filter(Boolean).join(' ') || undefined
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-ink-secondary mb-1">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={`${fieldControl(error)} min-h-[120px] resize-y leading-normal ${className}`}
        {...props}
      />
      {hint && !error && <p id={hintId} className="mt-1 text-xs text-ink-muted">{hint}</p>}
      {error && <p id={errorId} role="alert" className="mt-1 text-sm text-err-ink">{error}</p>}
    </div>
  )
})
